import React from "react";
import { Box, Heading, SimpleGrid, Text, VStack } from "@chakra-ui/react";
import Section from "./Section";
import { solutions } from "../data/content";

export default function Solutions() {
  return (
    <Section
      id="solutions"
      bg="ink.50"
      title="Our Core Solutions"
      subtitle="Everything a working laboratory needs, from a single supplier."
    >
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        {solutions.map((solution, idx) => (
          <Box
            key={solution.title}
            bg="white"
            borderRadius="xl"
            p={{ base: 7, md: 8 }}
            border="1px solid"
            borderColor="ink.100"
            transition="border-color 0.2s, transform 0.2s"
            _hover={{ borderColor: "brand.300", transform: "translateY(-3px)" }}
          >
            <Text fontSize="sm" fontWeight={700} color="brand.600" mb={2}>
              {String(idx + 1).padStart(2, "0")}
            </Text>
            <Heading as="h3" fontSize="xl" mb={4}>
              {solution.title}
            </Heading>
            <VStack as="ul" align="stretch" spacing={2} listStyleType="none">
              {solution.items.map((item) => (
                <Box as="li" key={item} display="flex" gap={3} alignItems="baseline">
                  <Box w="5px" h="5px" borderRadius="full" bg="brand.500" flexShrink={0} />
                  <Text color="ink.600">{item}</Text>
                </Box>
              ))}
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </Section>
  );
}
